import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Steps,
    Button,
    message,
    Form,
    Input,
    Image,
    Carousel,
    Card,
    Divider,
    Select,
    DatePicker,
    Radio,
    Checkbox,
    Space,
    Avatar,
    Spin,
    Tag
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import accountService from "../../../api/account.service";

import { ADD_MODE, CR_TAG, DATE_FORMAT_DMY_SLASH, DR_TAG, EDIT_MODE, SAVE_SUCCESS_MSG, SUCCESS_STATUS, UPDATE_SUCCESS_MSG } from "../../../utility/Constants";
import ModalWithMessageAndAction from "../../common/ModalWithMessageAndAction";

import moment from "moment";
import commonUtility from "../../../utility/Utils";
import AccountDrCrDetailsGeneral from "../accountdetails/AccountDrCrDetailsGeneral";
import AccountDrCrDetailsGeneralSingleRow from "../accountdetails/AccountDrCrDetailsGeneralSingleRow";
import { PRINT_BASE_URL } from "../../../utility/URL";

const { Option } = Select;
const { TextArea } = Input;

const defaultFormValues = {
    voucher_id: 0,
    voucher_no: "",
    voucher_date: "",
    mode: "ADD",
    voucher_type: "",
    cheque_number: "",
    cheque_date: "",
    narration: "",
    total_dr_amount: 0,
    total_cr_amount: 0,
    voucher_details: []
};




const GeneralVoucherEntryView = () => {

    const [accountList, setAccountList] = useState([]);


    const [form] = Form.useForm();
    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");
    const [formErrorMessage, setFormErrorMessage] = useState("");
    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [totalDebitAmount, setTotalDebitAmount] = useState(0);
    const [totalCreditAmount, setTotalCreditAmount] = useState(0);

    const [transTagValue, setTransTagValue] = useState("");
    const [rcpyAmount, setRcpyAmount] = useState(0);
    const [remainingAmount, setRemainingAmount] = useState(0);

    const [voucherDetailsList, setVoucherDetailsList] = useState([]);

    const [detailErrorMessage, setDetailErrorMessage] = useState("");

    const [responseModal, setResponseModal] = useState({
        responseModalTitle: '',
        isOpenModal: false,
        listLink: '',
        addmoreLink: '',
        responseModalMessage: '',
        printReuired: false,
        printUrl:""
    });

    const params = useParams();


    /**
     * onGeneralVoucherSave
     */
    const onGeneralVoucherSave = async (values) => {

        const dr_amount = values.total_dr_amount;
        const cr_amount = values.total_cr_amount;

    

        if (dr_amount > 0 && cr_amount > 0) {
            if (validateAmount()) {
                setSaveLoaderEnable(true)

                setResponseModal({
                    responseModalTitle: '',
                    isOpenModal: false,
                    listLink: '',
                    addmoreLink: '',
                    responseModalMessage: '',
                    printReuired: false,
                    printUrl:""
                });

                const data = { formdata: values };
                const response = accountService.generalVoucherSave(data).then((resdata) => {

                    
                    if (resdata.response_data.mode == ADD_MODE) {
           
                        // setOpenModal(true)
                        // setResponseModalTitle("Success")
                        // setResponseModalMessage(`${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`)

                        const print_url = `${PRINT_BASE_URL}voucher/printpdf/${resdata.response_data.voucher_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`;

                        setResponseModal({
                            responseModalTitle: 'Success',
                            isOpenModal: true,
                            listLink: '/generalvoucher/list',
                            addmoreLink: '/generalvoucher/entry',
                            responseModalMessage: `${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`,
                            printReuired: true,
                            printUrl:print_url
                        });
                
                      }
                      else if(resdata.response_data.mode == EDIT_MODE) {
                        // setOpenModal(true)
                        // setResponseModalTitle("Success")
                        // setResponseModalMessage(`${UPDATE_SUCCESS_MSG}`)

                        const print_url = `${PRINT_BASE_URL}voucher/printpdf/${resdata.response_data.voucher_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`;


                        setResponseModal({
                            responseModalTitle: 'Success',
                            isOpenModal: true,
                            listLink: '/generalvoucher/list',
                            addmoreLink: '/generalvoucher/entry',
                            responseModalMessage: `${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`,
                            printReuired: true,
                            printUrl:print_url
                        });

                      }
    
                      setSaveLoaderEnable(false)
                     

                });
            }
            else {
                setFormErrorMessage("Error : Total Debit and Total Credit amount must be equal")
            }
        }
        else {
            setFormErrorMessage("Error : Total Debit and Total Credit amount must be greater than 0")
        }
    };

    const handleCancel = () => {
        setOpenModal(false);
    };



    const validateAmount = () => {
        let dr_amount = form.getFieldValue("total_dr_amount");
        let cr_amount = form.getFieldValue("total_cr_amount");

        if (dr_amount != cr_amount) { return false; }
        return true;
    }




    const onVoucherDateChange = (date, dateString) => {
        form.setFieldsValue({
            voucher_date: dateString,
        });
    };


    const onChequeDateChange = (date, dateString) => {
        form.setFieldsValue({
            cheque_date: dateString,
        });
    };


    useEffect(() => {
        accountService.accountListForContra().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);


    /**
     * EDIT DATA
     */

    useEffect(() => {
        //console.log("Voucher ID",params.voucher_id)

        if (params.voucher_id && params.voucher_id > 0) {

            const data = {
                formdata: {
                    voucher_master_id: params.voucher_id,
                },
            };



            accountService.generalVoucherEditData(data).then((res) => {

                if (res.response_status === SUCCESS_STATUS) {
                    setTotalDebitAmount(0)
                    setTotalCreditAmount(0)
                    const voucher_data = res.response_data[0];

                    console.log("voucher_dat", voucher_data)
                    form.setFieldsValue({
                        mode: "EDIT",
                        voucher_no: voucher_data.masterData.voucher_no,
                        voucher_id: voucher_data.masterData.id,
                        //voucher_date_picker,
                        voucher_date: commonUtility.dateFormatDDMMYYYY(new Date(voucher_data.masterData.voucher_date), "/"),
                        voucher_date_picker: voucher_data.masterData.VoucherDate ? moment(voucher_data.masterData.VoucherDate, DATE_FORMAT_DMY_SLASH) : '',

                        voucher_type:voucher_data.masterData.voucher_type,
                        paid_to:voucher_data.masterData.paid_to,

                        dr_cr_account_tag:voucher_data.masterData.voucher_type == "RC" ? DR_TAG : CR_TAG,
                        ac_tag:voucher_data.masterData.voucher_type == "RC" ? CR_TAG : DR_TAG,
                        bank_cash_account_id:voucher_data.masterData.account_master_id,
                        rc_py_amount:voucher_data.masterData.amount,

                        cheque_date: commonUtility.dateFormatDDMMYYYY(new Date(voucher_data.masterData.cheque_date), "/"),
                        cheque_date_picker: voucher_data.masterData.chequeDate ? moment(voucher_data.masterData.chequeDate, DATE_FORMAT_DMY_SLASH) : '',

                        cheque_number: voucher_data.masterData.cheque_number,
                        narration: voucher_data.masterData.narration,

                        total_dr_amount: voucher_data.masterData.total_dr_amt,
                        total_cr_amount: voucher_data.masterData.total_cr_amt,
                    })



                    let detailsDataList = voucher_data.detailsData

                    const newData = detailsDataList.map(details => {
                        return {...{
                                     ac_tag: details.tran_tag,
                                     account_id: details.account_master_id,
                                     amount: details.amount,
                                     account_title:details.account_name

                                }}
                        });
                        setVoucherDetailsList(newData);

                  
                    setTotalDebitAmount(voucher_data.masterData.total_dr_amt)
                    setTotalCreditAmount(voucher_data.masterData.total_cr_amt)
                }
            });

        }


    }, [params.voucher_id]);




    /**
     * Add Single Account Details
     */
    const addVoucherDetails = () => {
        setDetailErrorMessage("")
        const ac_tag = form.getFieldValue('ac_tag');
        const account_id = form.getFieldValue('account_id');
        const account_title = form.getFieldValue('account_title');
        const amount = form.getFieldValue('amount');



        if (commonUtility.sanitizeObject(ac_tag) && commonUtility.sanitizeValue(account_id) && commonUtility.sanitizeValue(amount) > 0) {
            //let amount = parseFloat(paid_amount)+parseFloat(bank_charges_amount);
            setVoucherDetailsList([...voucherDetailsList, {
                ac_tag: ac_tag,
                account_id: account_id,
                account_title: account_title,
                amount: amount,
            }]);

            form.setFieldsValue({
                account_id: "",
                account_title: "",
            });
        }
        else{
            setDetailErrorMessage("Error : Tag / Account / Amount are required. And amount must be greater than 0")
        }
    }


    /**
     * 
     * @param Remove Voucher Details
     */
    const removeVocherDetail = (index) => {
        const list = [...voucherDetailsList];
        list.splice(index, 1);
        setVoucherDetailsList(list);

    }



    const onFormFieldsChange = () => {
        setDetailErrorMessage("")
        setFormErrorMessage("")
    }

    const onChangeTransType = (value, event) => {

        setVoucherDetailsList([])
        let dr_ac_tag = "";
        if (value == "RC") {
            dr_ac_tag = DR_TAG
        }
        else {
            dr_ac_tag = CR_TAG
        }

        form.setFieldsValue({
        //    rc_py_amount: 0,
            dr_cr_account_tag: dr_ac_tag
        });

        let amount = form.getFieldValue("rc_py_amount");
        calAmountBaseOnRcAmt(value, amount)

    }

    const onRcPyAmountChnage = (val) => {
        let trans_tag = form.getFieldValue("voucher_type");
        let amount = val.target.value;
        console.log("Ammt",amount)
        calAmountBaseOnRcAmt(trans_tag, amount)
    }

    const calAmountBaseOnRcAmt = (tran_tag, amount) => {
        setTotalDebitAmount(0)
        setTotalCreditAmount(0)

        setTransTagValue("")
        setTransTagValue(tran_tag)

        //setRcpyAmount(0)
       // setRcpyAmount(amount)

        const total_voucher_amount = voucherDetailsList.reduce((a, v) => a = a + parseFloat(v.amount), 0);
        const remainingAMount = parseFloat(amount) - parseFloat(total_voucher_amount)


        if (tran_tag == "RC") {
            //amount debited
            form.setFieldsValue({
                total_dr_amount: amount,
                total_cr_amount: total_voucher_amount,
                ac_tag: 'Cr',
                amount: remainingAMount,
            });

            setTotalDebitAmount(amount)
            setTotalCreditAmount(total_voucher_amount)

        } else {
            form.setFieldsValue({
                total_cr_amount: amount,
                total_dr_amount: total_voucher_amount,
                ac_tag: 'Dr',
                amount: remainingAMount,
            });

            setTotalCreditAmount(amount)
            setTotalDebitAmount(total_voucher_amount)

        }

        //setRemainingAmount(remainingAMount)
    }

    useEffect(() => {

        const rc_py_amount = commonUtility.sanitizeValue(form.getFieldValue("rc_py_amount"));
        const total_voucher_amount = voucherDetailsList.reduce((a, v) => a = a + parseFloat(v.amount), 0);
        const remainingAMount = parseFloat(rc_py_amount) - parseFloat(total_voucher_amount)

        //setRemainingAmount(remainingAMount)

        
     
        if (form.getFieldValue('voucher_type') == "RC") {
            form.setFieldsValue({
                total_cr_amount: total_voucher_amount,
            });
            setTotalCreditAmount(total_voucher_amount)
            

        } else {
            form.setFieldsValue({
                total_dr_amount: total_voucher_amount,
            });
            setTotalDebitAmount(total_voucher_amount)
        }

        form.setFieldsValue({
            amount: remainingAMount,
        })
    

    }, [voucherDetailsList])




    return (
        <div>
            <div className="form-input-style">
                <Row
                    className="login-first-step-row"
                    style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
                >
                    <Col className="login-first-step-block-1" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onGeneralVoucherSave}
                            autoComplete="off"
                            initialValues={defaultFormValues}
                            className="basicRegForm"
                            onFieldsChange={(event) => onFormFieldsChange()}
                            // onValuesChange={(event) => onFormCalculation()}
                            onKeyUp={onFormFieldsChange}
                            onBlur={onFormFieldsChange}
                            style={{ padding: "10px 20px" }}
                        >

                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={7}>
                                    <Form.Item name="voucher_no" label="Voucher No">
                                        <Input placeholder="" readOnly={true} />
                                    </Form.Item>

                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="voucher_id" label="vid" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_dr_amount" label="tda " hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_cr_amount" label="tca " hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="voucher_details" label="vd " hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="voucher_date_picker" label="Voucher Date" rules={[
                                        {
                                            required: true,
                                            message: 'Voucher Date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onVoucherDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="voucher_date" label="Voucher Dt" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} xl={7}>
                                    <Form.Item name="voucher_type" label="Receipt/Payment">
                                        <Select
                                            onSelect={(value, event) => onChangeTransType(value, event)}
                                        >
                                            <Option key="RcTag" value="RC">Receipt</Option>
                                            <Option key="PyTag" value="PY">Payment</Option>
                                        </Select>

                                    </Form.Item>
                                    <Form.Item name="dr_cr_account_tag" label="DrCrActag" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={7}>
                                    <Form.Item name="paid_to" label="Paid To / Received From">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={20}>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="cheque_number" label="Cheque No">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>



                                <Col xs={24} xl={7}>
                                    <Form.Item name="cheque_date_picker" label="Cheque Date" >
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onChequeDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="cheque_date" label="Chq Dt" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={7}>
                                    <Form.Item

                                        label="Bank/Cash"
                                        name="bank_cash_account_id"


                                    //  onChange={(e,index) => onDebitCreditChange(index)}
                                    >
                                        <Select
                                            className="text-left"
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            allowClear={true}
                                        >

                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={7}>
                                    <Form.Item name="rc_py_amount" label="amount" onChange={(val) => onRcPyAmountChnage(val)}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={14}>
                                    <Form.Item name="narration" label="Narration">
                                        <TextArea rows={1} placeholder="" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={14}>
                                    <div style={{ marginTop: "1.5rem" }}>
                                        <AccountDrCrDetailsGeneralSingleRow form={form} voucherDetailsList={voucherDetailsList} removeVocherDetail={removeVocherDetail} addVoucherDetails={addVoucherDetails} transTagValue={transTagValue} detailErrorMessage={detailErrorMessage} />
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={20} style={{ marginTop: "1rem" }}>
                                <Col xs={24} xl={7}>
                                    <h3>Total Debit Amount : {totalDebitAmount}</h3>
                                </Col>
                                <Col xs={24} xl={7} align="right">
                                    <h3>Total Credit Amount : {totalCreditAmount}</h3>
                                </Col>
                            </Row>



                            <Row gutter={20}>
                                <Col xs={24} xl={12} >
                                    {
                                        formErrorMessage.length > 0 ? <><Tag color="error">{formErrorMessage}</Tag></> : ''
                                    }

                                </Col>
                                <Col xs={24} xl={2}>
                                    <Form.Item>
                                        {/* <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button> */}





                                        {
                                            isSaveLoaderEnable ? <Spin /> : <>
                                                <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button>
                                            </>
                                        }
                                        {/* <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button> */}

                                    </Form.Item>
                                </Col>
                            </Row>





                        </Form>
                    </Col>

                </Row>
            </div>


            {/* <ModalWithMessageAndAction key={commonUtility.randomID()} responseModalTitle={responseModalTitle} openModal={openModal} handleCancel={handleCancel} listLink={'/generalvoucher/list'} addmoreLink={'/generalvoucher/entry'} responseModalMessage={responseModalMessage} /> */}
            {
                responseModal.isOpenModal ? <>
                    <ModalWithMessageAndAction responseModal={responseModal} />
                </> : <></>
            }

        </div>
    )
}

export default GeneralVoucherEntryView